import React, { Component } from 'react'
import {
    Link
} from 'react-router-dom'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import StandardList from "../../common/listing/list.component.jsx";
import Icon from "../../common/icon/icon.component.jsx"
import MyAccountTabs from '../../common/layout/tabs/myaccount.component.jsx';
import {AppContext} from '@lightspeed-invoicing/core-client/frontend';
import SideBar from '../../common/layout/sidebar.component.jsx';
import {TaxSettings} from "./TaxSettings"

class TaxSection extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            className: this.props.className || '',
            taxes: [],
            defaultTax: null,
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        AppContext.getApiClient().get('/taxes').then((resTaxes) => {
            AppContext.getApiClient().get('/taxes/default').then((resDefault) => {
                this.setState({
                    taxes: resTaxes.data,
                    defaultTax: resDefault
                })
            })
        })
    }

    renderTaxContent(taxes) {

        if (taxes.length === 0) {
            return (
                <div>
                    <FormattedMessage
                        id="tax.form.listing.no_tax_defined"
                        defaultMessage="No taxes have been defined."
                    />
                </div>
            )
        }
        else {
            return <StandardList
                className="row pt-0 mt-3"
                headers={this.taxesHeaders()}
                rows={taxes.map(t => this.taxesRow(t))}
                smallLine={true}
            />

        }
    }

    taxesHeaders() {
        return [
            <FormattedMessage
                id="tax.form.listing.th.name"
                defaultMessage="Name"
            />,
            <FormattedMessage
                id="tax.form.listing.th.description"
                defaultMessage="Description"
            />,
            <FormattedMessage
                id="tax.form.listing.th.rate"
                defaultMessage="Rate"
            />,
        ]
    }

    taxesRow(item) {
        const defaultTax = this.state.defaultTax
        let defaultBadge = null;
        if (defaultTax.id === item.id) {
            defaultBadge =
                <FormattedMessage
                    id="tax.form.listing.default_label"
                    defaultMessage="Default"
                >
                    {(txt) => (
                        <span className="badge badge-secondary">
                            {txt}
                        </span>
                    )}
                </FormattedMessage>

        }
        return [
            <Link to={"/settings/editTax/" + item.id}>{item.attributes.name} &nbsp;{defaultBadge}</Link>,
            item.attributes.description,
            <FormattedNumber
                style={'percent'}
                maximumFractionDigits={4}
                value={item.attributes.totalRate/100}
            />,
        ]
    }

    render() {
        const taxContent = this.renderTaxContent(this.state.taxes)
        return (
            <div>
                <MyAccountTabs/>
                <TaxSettings/>
                <div className="row ui-has-modules py-1">
                    <div className="col-12 ui-module mb-0">
                        <div className="row mb-0 justify-content-end">
                            <div className="col-3 text-align-right ">
                                <Link to="/settings/newTax" className="btn btn-primary">
                                    <Icon value={"plus-circle"}/>
                                    <FormattedMessage
                                        id="tax.form.listing.add_tax_btn"
                                        defaultMessage="Create tax"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                {taxContent}
            </div>
        )
    }

}

export default TaxSection


// WEBPACK FOOTER //
// ./src/settings/taxes/taxSection.component.jsx